import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';

import { styled } from '@mui/material/styles';
import TextField, { TextFieldProps } from '@mui/material/TextField';

const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiInputBase-input': {
    '&::placeholder': {
      color: theme.palette.neutral[200],
    },
    color: theme.palette.neutral[200],
    padding: 0,
  },
  '& .MuiInputBase-root': {
    '&.MuiInputBase-sizeSmall': {
      height: 40,
    },
    backgroundColor: theme.palette.background.paper,
    border: 'none',
    borderRadius: 12,
    height: 52,
    padding: '0 12px',
    width: '100%',
  },
}));

export function SearchField({ onClear, ...props }: TextFieldProps & { onClear?: () => void }) {
  return (
    <StyledTextField
      {...props}
      slotProps={{
        input: {
          startAdornment: <SearchIcon sx={{ fontSize: 20, marginRight: 1 }} />,
          ...(onClear && !!props.value
            ? {
                endAdornment: (
                  <IconButton onClick={onClear} size={props.size}>
                    <CloseIcon fontSize={props.size} />
                  </IconButton>
                ),
              }
            : {}),
        },
      }}
    />
  );
}
